<app-template-select
  [disabled]="disabled"
  [value]="value"
  [control]="control"
  [required]="required"
  [options]="options"
  [multiple]="multiple"
  [label]="label"
  [selectFirstIfEmpty]="false"
/>
